/**
 * Получения стилей бабла из свойств компонента
 * @param {Object} props
 * @param {Object} return
 */
export var getBubbleStyle = function getBubbleStyle() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var backgroundColor = props.backgroundColor,
        textColor = props.textColor,
        borderColor = props.borderColor;


    var style = {};

    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }

    if (textColor) {
        style.color = textColor;
    }

    if (borderColor) {
        style.border = "1px solid " + borderColor;
    }

    return style;
};